import { Eye, EyeOff, Lock, User } from 'lucide-react'
import { Formik } from 'formik'
import { useContext, useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import logo from '../../assets/baj_logo.png'
import { setAuthToken } from '../../config/api.js'
import api from '../../config/AxiosInstance.js'
import { UserContext } from '../../context/userContext'
import * as Common from '../../utils/Common.js'
import { loginSchema } from '../../utils/validationSchema.js'
import { useWarehouseRole } from '../../context/WarehouseProvider.jsx'
import { APP_VERSION } from '../../config/version.js'
import styles from './login.module.css'

const Index = () => {
  const [, dispatch] = useContext(UserContext)
  const [showPassword, setShowPassword] = useState(false)
  const { updateWarehouseRole } = useWarehouseRole()

  const handleSubmit = async (values) => {
    try {
      const response = await api.post('/users/login', values)

      if (response.data.success) {
        if (['RnR', 'LOAD'].includes(response.data.data.role.role_code)) {
          throw new Error('You are not allowed to access this page')
        }
        setAuthToken(response.data.data.token)
        updateWarehouseRole(response.data.data.roles[0].warehouse_id)
        const dataPayload = {
          ...response.data.data,
          warehouse_active: response.data.data.roles[0].warehouse_id
        }
        dispatch({
          type: 'login',
          payload: dataPayload
        })
        window.location.href = '/dashboard'
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className={styles.loginContainer}>
      <Card className={styles.loginCard}>
        <Card.Body className={styles.cardBody}>
          <div className={styles.logoContainer}>
            <img src={logo} alt="baj" className={styles.logo} />
            <h2 className={styles.appTitle}>Warehouse Management System</h2>
            <p className={styles.welcomeText}>Sign in to your account</p>
          </div>

          <Formik
            initialValues={{
              username: '',
              password: ''
            }}
            validationSchema={loginSchema}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <div className={styles.inputGroup}>
                    <User size={18} className={styles.inputIcon} />
                    <Form.Control
                      type="text"
                      placeholder="Username"
                      name="username"
                      value={values.username}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      isInvalid={!!errors.username && touched.username}
                      className={styles.formControl}
                    />
                    {touched.username && !!errors.username && (
                      <div className={styles.errorMessage}>
                        {errors.username}
                      </div>
                    )}
                  </div>

                  <div className={styles.inputGroup}>
                    <Lock size={18} className={styles.inputIcon} />
                    <Form.Control
                      type={!showPassword ? 'password' : 'text'}
                      placeholder="Password"
                      name="password"
                      value={values.password}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      isInvalid={touched.password && !!errors.password}
                      className={styles.formControl}
                    />
                    <div
                      className={styles.passwordToggle}
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                    </div>
                    {touched.password && errors.password && (
                      <div className={styles.errorMessage}>
                        {errors.password}
                      </div>
                    )}
                  </div>

                  <Button
                    type="submit"
                    className={styles.loginBtn}
                    disabled={!isValid || !dirty}
                  >
                    Login
                  </Button>
                </Form>
              )
            }}
          </Formik>
          <div className="text-center mt-3 text-muted small">
            v{APP_VERSION}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default Index
